import Vue from "vue";
import "babel-polyfill";
import router from "./router";
import ElementUI, { Button } from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import VueWecharTitleTitle from "vue-wechat-title";
import App from "./App";
import myElementUi from "./components/utils/index";
import store from "./store/store";
import * as custom from "@/filters/filters.js";
import mixin from "@/mixin/mixincopy.js";
import { getLocal } from "./filters/filters";
import http from "./service/apiscopy";
import Viewer from "v-viewer";
import "viewerjs/dist/viewer.css";
import exportBtn from "./components/export-button";
import * as echarts from "echarts";
Vue.prototype.$echarts = echarts;

// 视频播放插件，放组件里
// import VideoPlayer from 'vue-video-player'
// require('video.js/dist/video-js.css')
// require('vue-video-player/src/custom-theme.css')
// Vue.use(VideoPlayer);

Vue.component("exportBtn", exportBtn);

Object.keys(custom).forEach(key => {
  Vue.filter(key, custom[key]);
});

Vue.use(Viewer);
Vue.mixin(mixin);
Vue.use(ElementUI);
Vue.use(VueWecharTitleTitle);
Vue.use(myElementUi);
Vue.directive("v-change", {
  inserted: function(el, binding) {
    let timer;
    el.addEventListener("change", () => {
      if (timer) {
        clearTimeout(timer);
      }
      timer = setTimeout(() => {
        binding.value();
      }, 300);
    });
  }
});

// require('./mock'); //引入mock数据，关闭则注释该行
Vue.config.productionTip = false;

// vue-devTools 正式禁用
const isDebug_mode = process.env.NODE_ENV !== "production";
Vue.config.devtools = isDebug_mode;

Vue.prototype.$http = http;
Vue.prototype.HeaderOptions = {
  Authorization: getLocal("Authorization")
};
// http.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8';  // 请求报错 415

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  store,
  render: h => h(App),
  created() {},
  data: {
    eventHub: new Vue()
  }
});
// 配置路由名称
router.beforeEach((to, from, next) => {
  // // 记住密码用 暂时注掉
  if (to.matched.some(record => record.meta.auth)) {
    //此路由需要验证，请检查是否已登录
    //如果没有，重定向到登录页面
    if (!getLocal("userMessage")) {
      next({
        path: "/login",
        query: { redirect: to.fullPath }
      });
    } else {
      next();
    }
  } else {
    next(); // 确保一定要调用 next()
  }
  // if (to.name === "login") {
  //   next();
  // }

  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  // next();
});



// WEBPACK FOOTER //
// ./src/main.js